import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@environments/environment';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BusComponent } from './components/bus/bus.component';
import { MapService } from './components/map/map-services/map.service';
import { MapComponent } from './components/map/map.component';
import { MenuComponent } from './components/menu/menu.component';
import { SaveFavoritesComponent } from './components/save-favorites/save-favorites.component';
import { StopsComponent } from './components/stops/stops.component';
import { TimesComponent } from './components/times/times.component';
import { ViewFavoritesComponent } from './components/view-favorites/view-favorites.component';
import { RequestDestroyInterceptor } from './shared/services/request-destroy.interceptor';
import { SharedModule } from './shared/shared.module';
import { ThemesModule } from './themes/themes.module';
import { RatesComponent } from './components/rates/rates.component';
import { NoticesComponent } from './components/notices/notices.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ApiSaeModule } from './api-sae.module';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    BusComponent,
    StopsComponent,
    TimesComponent,
    MenuComponent,
    SaveFavoritesComponent,
    ViewFavoritesComponent,
    RatesComponent,
    NoticesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LoggerModule.forRoot({
      serverLoggingUrl: '/api/logs',
      level: !environment.production ? NgxLoggerLevel.DEBUG : NgxLoggerLevel.OFF,
      serverLogLevel: NgxLoggerLevel.ERROR,
      enableSourceMaps: !environment.production ? true : false,
    }),
    SharedModule,
    ThemesModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    ApiSaeModule,
  ],
  providers: [
    MapService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestDestroyInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
